/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=e9e580b8&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=e9e580b8&lang=less"

import exportComponent from "C:\\Users\\10938\\Desktop\\ysjf1\\采购\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9e580b8"]])

export default __exports__